export type NotificationType = 'success' | 'error' | 'info';

export enum EAlertSubmitType {
  OK = 'OK',
  CANCEL = 'CANCEL'
}

export interface IMobileAlertParams {
  type?: NotificationType;
  error?: boolean;
  refresh?: boolean;
  message: string;
  title?: string;
  id?: string;
  submitType?: EAlertSubmitType;
  noButton?: boolean;
  absoluteAlert?: boolean;
  onAfterCancel?: () => void;
  onBeforeCancel?: () => void;

  /**
   * Parameter to determine whether to add a delay before the display of an alert message
   *
   * Primarily used for ensuring that concurrent native Modals are not triggered at the same time,
   * which may cause mobile alerts to not be displayed on iOS mobile app
   * https://github.com/react-native-modal/react-native-modal?tab=readme-ov-file#i-cant-show-multiple-modals-one-after-another
   */
  shouldDelay?: boolean;
  /** Parameter to indicate custom delay duration (defaults to 750 ms) */
  customDelaySeconds?: number;
}

export interface IWebAlertParams {
  type?: NotificationType;
  title?: string;
  message: string;
  delay?: number;
  onClose?: () => void;
}

export type IAlertHandlerProps = IWebAlertParams | IMobileAlertParams;

export interface IAlertHandler {
  alert: (params: IAlertHandlerProps) => void;
}
